import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-564e4678"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-fluid p-formgrid p-grid p-input-filled" }
const _hoisted_2 = { class: "p-field p-col-6" }
const _hoisted_3 = { for: "interfaceName" }
const _hoisted_4 = {
  key: 0,
  class: "p-error"
}
const _hoisted_5 = { class: "p-field p-col-6" }
const _hoisted_6 = { for: "description" }
const _hoisted_7 = {
  key: 0,
  class: "p-error"
}
const _hoisted_8 = ["for"]
const _hoisted_9 = ["for"]
const _hoisted_10 = {
  class: "mdi mdi-comment-question-outline",
  style: {"vertical-align":"middle"}
}
const _hoisted_11 = ["for"]
const _hoisted_12 = {
  class: "mdi mdi-comment-question-outline",
  style: {"vertical-align":"middle"}
}
const _hoisted_13 = ["for"]
const _hoisted_14 = {
  key: 12,
  class: "p-error"
}
const _hoisted_15 = { class: "p-field p-col-12" }
const _hoisted_16 = { for: "active" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_InputIcon = _resolveComponent("InputIcon")!
  const _component_Password = _resolveComponent("Password")!
  const _component_IconField = _resolveComponent("IconField")!
  const _component_Chip = _resolveComponent("Chip")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.Type')) + " *", 1),
      _createVNode(_component_Dropdown, {
        id: "interfaceName",
        style: {"min-width":"15.625rem"},
        modelValue: _ctx.value.interfaceName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value.interfaceName) = $event)),
        options: _ctx.allExportInterfaces,
        optionValue: "id",
        optionLabel: "name",
        filter: true,
        autoFilterFocus: true,
        class: _normalizeClass({'p-invalid':_ctx.v$.interfaceName.$invalid && _ctx.showErrorMessage}),
        onChange: _ctx.update,
        disabled: !!_ctx.value.id,
        onShow: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDropdownOverlay(_ctx.allExportInterfaces)))
      }, null, 8, ["modelValue", "options", "class", "onChange", "disabled"]),
      ((!_ctx.v$.interfaceName.$model && _ctx.showErrorMessage))
        ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.DocumentClasses.Type')})), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.Description')) + " *", 1),
      _createVNode(_component_InputText, {
        id: "description",
        modelValue: _ctx.value.description,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.value.description) = $event)),
        modelModifiers: { trim: true },
        class: _normalizeClass({'p-invalid':_ctx.v$.description.$invalid && _ctx.showErrorMessage}),
        onChange: _ctx.update,
        required: "true"
      }, null, 8, ["modelValue", "class", "onChange"]),
      (_ctx.v$.description.$invalid && _ctx.showErrorMessage)
        ? (_openBlock(), _createElementBlock("small", _hoisted_7, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.DocumentClasses.Description')})), 1))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getExportInterfaceProperties(_ctx.value.interfaceName), (property, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["p-field", property.type === 'sequenceFromSet' ? 'p-col-12' : 'p-col-6'])
      }, [
        (property.optional && property.id !== 'SharePointGraphApiDrive')
          ? (_openBlock(), _createElementBlock("label", {
              key: 0,
              for: property.id
            }, _toDisplayString(property.name), 9, _hoisted_8))
          : (property.optional && property.id === 'SharePointGraphApiDrive')
            ? (_openBlock(), _createElementBlock("label", {
                key: 1,
                for: property.id
              }, [
                _createTextVNode(_toDisplayString(property.name) + " ", 1),
                _withDirectives(_createElementVNode("i", _hoisted_10, null, 512), [
                  [_directive_tooltip, _ctx.$t('Squeeze.DocumentClasses.SharepointGraphApiDriveFieldInfo')]
                ])
              ], 8, _hoisted_9))
            : (!property.optional && property.id === 'SharePointGraphApiDrive')
              ? (_openBlock(), _createElementBlock("label", {
                  key: 2,
                  for: property.id
                }, [
                  _createTextVNode(_toDisplayString(property.name) + " * ", 1),
                  _withDirectives(_createElementVNode("i", _hoisted_12, null, 512), [
                    [_directive_tooltip, _ctx.$t('Squeeze.DocumentClasses.SharepointGraphApiDriveFieldInfo')]
                  ])
                ], 8, _hoisted_11))
              : (_openBlock(), _createElementBlock("label", {
                  key: 3,
                  for: property.id
                }, _toDisplayString(property.name) + " *", 9, _hoisted_13)),
        (property.type === 'string' && property.optional)
          ? (_openBlock(), _createBlock(_component_InputText, {
              key: 4,
              id: property.id,
              modelValue: _ctx.value.configuration[property.id],
              "onUpdate:modelValue": ($event: any) => ((_ctx.value.configuration[property.id]) = $event),
              modelModifiers: { trim: true },
              onChange: _ctx.update
            }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "onChange"]))
          : (property.type === 'string' && !property.optional)
            ? (_openBlock(), _createBlock(_component_InputText, {
                key: 5,
                id: property.id,
                modelValue: _ctx.value.configuration[property.id],
                "onUpdate:modelValue": ($event: any) => ((_ctx.value.configuration[property.id]) = $event),
                modelModifiers: { trim: true },
                onChange: _ctx.update
              }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "onChange"]))
            : (property.type === 'int')
              ? (_openBlock(), _createBlock(_component_InputNumber, {
                  key: 6,
                  id: property.id,
                  modelValue: _ctx.value.configuration[property.id],
                  "onUpdate:modelValue": ($event: any) => ((_ctx.value.configuration[property.id]) = $event),
                  onChange: _ctx.update
                }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "onChange"]))
              : _createCommentVNode("", true),
        (property.type === 'password')
          ? (_openBlock(), _createBlock(_component_IconField, { key: 7 }, {
              default: _withCtx(() => [
                (_ctx.value.configuration[property.id].isSet)
                  ? _withDirectives((_openBlock(), _createBlock(_component_InputIcon, {
                      key: 0,
                      class: "mdi mdi-close",
                      style: {"cursor":"pointer"},
                      onClick: ($event: any) => ((_ctx.value.configuration[property.id].value = '', _ctx.value.configuration[property.id].isSet = false, _ctx.update()))
                    }, null, 8, ["onClick"])), [
                      [
                        _directive_tooltip,
                        _ctx.$t('Squeeze.General.Delete'),
                        void 0,
                        { bottom: true }
                      ]
                    ])
                  : _createCommentVNode("", true),
                _createVNode(_component_Password, {
                  id: property.id,
                  modelValue: _ctx.value.configuration[property.id].value,
                  "onUpdate:modelValue": ($event: any) => ((_ctx.value.configuration[property.id].value) = $event),
                  modelModifiers: { trim: true },
                  placeholder: _ctx.value.configuration[property.id].isSet ? '*****' : '',
                  onChange: _ctx.update,
                  feedback: false
                }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "placeholder", "onChange"])
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true),
        (property.type === 'select' && property.optional && property.id !== 'SharePointExportFolderStructure')
          ? (_openBlock(), _createBlock(_component_Dropdown, {
              key: 8,
              style: {"min-width":"15.625rem"},
              modelValue: _ctx.value.configuration[property.id],
              "onUpdate:modelValue": ($event: any) => ((_ctx.value.configuration[property.id]) = $event),
              modelModifiers: { trim: true },
              options: property.options,
              optionValue: "id",
              optionLabel: "name",
              onChange: _ctx.update,
              onShow: ($event: any) => (_ctx.showDropdownOverlay(property.options))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange", "onShow"]))
          : (property.type === 'select' && !property.optional && property.id !== 'SharePointExportFolderStructure')
            ? (_openBlock(), _createBlock(_component_Dropdown, {
                key: 9,
                style: {"min-width":"15.625rem"},
                modelValue: _ctx.value.configuration[property.id],
                "onUpdate:modelValue": ($event: any) => ((_ctx.value.configuration[property.id]) = $event),
                modelModifiers: { trim: true },
                options: property.options,
                optionValue: "id",
                optionLabel: "name",
                onChange: _ctx.update,
                onShow: ($event: any) => (_ctx.showDropdownOverlay(property.options))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange", "onShow"]))
            : (property.type === 'bool')
              ? (_openBlock(), _createBlock(_component_Dropdown, {
                  key: 10,
                  style: {"min-width":"15.625rem"},
                  modelValue: _ctx.value.configuration[property.id],
                  "onUpdate:modelValue": ($event: any) => ((_ctx.value.configuration[property.id]) = $event),
                  options: _ctx.listOfBooleans,
                  optionValue: "id",
                  optionLabel: "name",
                  onChange: _ctx.update,
                  onShow: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDropdownOverlay(_ctx.listOfBooleans)))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"]))
              : (property.type === 'sequenceFromSet')
                ? (_openBlock(), _createBlock(_component_MultiSelect, {
                    key: 11,
                    style: {"min-width":"15.625rem"},
                    modelValue: _ctx.value.configuration[property.id],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.value.configuration[property.id]) = $event),
                    options: property.options,
                    optionValue: "id",
                    optionLabel: "name",
                    display: "chip",
                    filter: true,
                    autoFilterFocus: true,
                    onChange: _ctx.update,
                    onShow: ($event: any) => (_ctx.showDropdownOverlay(property.options))
                  }, {
                    value: _withCtx((slotProps) => [
                      _withDirectives((_openBlock(), _createElementBlock("div", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.value, (option, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: option }, [
                            (index <= 2)
                              ? (_openBlock(), _createBlock(_component_Chip, {
                                  key: 0,
                                  label: option,
                                  removable: "",
                                  class: "p-mr-2",
                                  onRemove: ($event: any) => (_ctx.onRemovePropertyOption(option))
                                }, null, 8, ["label", "onRemove"]))
                              : (index === 3)
                                ? (_openBlock(), _createBlock(_component_Chip, {
                                    key: 1,
                                    label: "...",
                                    class: "p-mr-2"
                                  }))
                                : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      ])), [
                        [
                          _directive_tooltip,
                          slotProps.value ? _ctx.mapTooltipValues(slotProps.value) : '',
                          void 0,
                          { bottom: true }
                        ]
                      ])
                    ]),
                    option: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.option.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "options", "onChange", "onShow"]))
                : _createCommentVNode("", true),
        (!property.optional
					&& (property.type === 'password'
					? (!_ctx.value.configuration[property.id].isSet && !_ctx.helpers.req((_ctx.value.configuration as any)[property.id!].value))
					: !_ctx.helpers.req(_ctx.value.configuration[property.id]))
					&& _ctx.showErrorMessage)
          ? (_openBlock(), _createElementBlock("small", _hoisted_14, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: property.name})), 1))
          : _createCommentVNode("", true)
      ], 2))
    }), 128)),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.Active')), 1),
      _hoisted_17,
      _createTextVNode("   "),
      _createVNode(_component_Checkbox, {
        id: "active",
        modelValue: _ctx.value.active,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.value.active) = $event)),
        binary: true
      }, null, 8, ["modelValue"])
    ])
  ]))
}